/**
 * @file Post Grid.
 */

/**
 * Post Grid component.
 */
const vPostGrid = () => {
	const postGrid = document.querySelector('.v-post-grid');

	if (!postGrid) {
		return;
	}

	document.addEventListener('facetwp-refresh', () => {
		postGrid.classList.add('v-post-grid--loading');
	});
	document.addEventListener('facetwp-loaded', () => {
		postGrid.classList.remove('v-post-grid--loading');
	});
};

export default vPostGrid;
